// Wrapper fino sobre las Cloud Functions de historial/tokens de IA (Postgres/Neon).
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const obtenerMiHistorialIAFn = httpsCallable(functions, 'obtenerMiHistorialIA');
const obtenerMisTokensIAFn = httpsCallable(functions, 'obtenerMisTokensIA');
const obtenerMisCreditosIAFn = httpsCallable(functions, 'obtenerMisCreditosIA');

export async function obtenerMiHistorialIA(assistant) {
  const result = await obtenerMiHistorialIAFn({ assistant });
  return result.data.historial;
}

export async function obtenerMisTokensIA() {
  const result = await obtenerMisTokensIAFn();
  return result.data;
}

// { ilimitado, creditosRestantes: number|null, role }
export async function obtenerMisCreditosIA() {
  const result = await obtenerMisCreditosIAFn();
  return result.data;
}
